module.exports = __webpack_public_path__ + "img/branding.5f1d77af.jpg";